import { createContext } from 'react';

const SearchResultsContext = createContext({
  // Default values
  searchParams: {},
  sendBreedSearchedAnalytics: () => {},
  referrer: null
});

export default SearchResultsContext;
